import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { Perm } from "@/lib/permissions"
import { requirePermission } from "@/lib/route-guards"
import { SettingsBillingPage } from "@/pages/settings/billing"

// Stripe Checkout redirects back here with ?checkout=success|cancelled.
const billingSearchSchema = z.object({
  checkout: z.enum(["success", "cancelled"]).optional(),
})

export const Route = createFileRoute("/_authenticated/settings/billing")({
  validateSearch: (search) => billingSearchSchema.parse(search),
  beforeLoad: async ({ context }) => {
    await requirePermission(context, Perm.BILLING_READ, { to: "/settings/general" })
  },
  component: SettingsBillingPage,
})
